import type { ThemeConfigV2 } from "@highereducation/dynamic-experience/utils";

/**
 * Provisional LP brand CSS var ← v2 `colors.primary` scale step mapping.
 * Update this table when Core DS / P1-T3 signs off — no other code changes needed.
 */
export const LP_BRAND_PRIMARY_FROM_V2_SCALE = {
  "--primary-1": "200",
  "--primary-2": "500",
  "--primary-3": "700",
  "--primary-4": "900",
} as const;

function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.length > 0;
}

/**
 * Maps a tenant theme's v2 `colors.primary` scale to LP brand CSS vars (--primary-1…4) on `:root`.
 * Native LP components consume these globals; DE tokens stay under `[data-de]` via convertThemeV2ToCSS.
 */
export function mapTenantThemeToLpPrimaryColorsCss(theme: ThemeConfigV2): string {
  const primaryScale = theme.colors?.primary;

  const lines = (Object.keys(LP_BRAND_PRIMARY_FROM_V2_SCALE) as Array<keyof typeof LP_BRAND_PRIMARY_FROM_V2_SCALE>)
    .map((cssVar) => {
      const step = LP_BRAND_PRIMARY_FROM_V2_SCALE[cssVar];
      const fromColors = primaryScale?.[step];
      if (isNonEmptyString(fromColors)) {
        return `  ${cssVar}: ${fromColors};`;
      }
      return null;
    })
    .filter((line): line is string => line !== null);

  if (lines.length === 0) {
    return "";
  }

  return `:root {\n${lines.join("\n")}\n}`;
}
